export default __webpack_public_path__ + "static/media/upIcon.1aff8dc5.svg";